import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import App from './App';
import SystemBrainPanel from './components/SystemBrainPanel';
import ResetPasswordPage from './components/ResetPasswordPage';
import PrivacyPage from './components/PrivacyPage';
import TermsPage from './components/TermsPage';
import SmsOptInPage from './components/SmsOptInPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/admin/system-brain" element={<SystemBrainPanel onClose={() => { window.location.pathname = '/'; }} />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      {/* Public legal pages — owner-requested 2026-09-29 for the 3A Communications 10DLC campaign; no auth gate. */}
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/sms-opt-in" element={<SmsOptInPage />} />
      <Route path="*" element={<App />} />
    </Routes>
  </BrowserRouter>
);
